<div id="add-resources-dialog" class="{{theme}}">
    <div mat-dialog-title>
        <div class="row">
            <div *ngIf="!content.contentId" class="col-md-10">
                <h3>Add Resources</h3>
            </div>
            <div *ngIf="content.contentId" class="col-md-10">
                <h3>Edit Resources</h3>
            </div>
            <div class="col-md-2">
                <span class="fa fa-close action-icons float-right ml-auto" (click)="close()"></span>
            </div>
        </div>
    </div>

    <div mat-dialog-content>
        <form class="resource-form">
            <mat-form-field class="col-md-10">
                <mat-label>Division</mat-label>
                <input matInput disabled name="division" [(ngModel)]="division" placeholder="Division" value="Toyota">
            </mat-form-field>
            <div class="col-md-10">
                <mat-label>Content Type</mat-label> &nbsp;&nbsp;
                <mat-button-toggle-group class="toggle-group" required name="contentType" #contentType=ngModel [(ngModel)]="content.featureType"
                    appearance="legacy" name="fontStyle" aria-label="Font Style">
                    <mat-button-toggle value="internal">Internal</mat-button-toggle>
                    <mat-button-toggle value="external">External</mat-button-toggle>
                    <mat-button-toggle value="both">Both</mat-button-toggle>
                </mat-button-toggle-group>
                <mat-error *ngIf="isSubmit && contentType.invalid">
                    <div *ngIf="contentType.errors.required">Content Type is required</div>
                </mat-error>
            </div>
            <mat-form-field class="col-md-10">
                <mat-label>Resource Name</mat-label>
                <input matInput required autocomplete="off" name="resourceName" #resourceName=ngModel [(ngModel)]="content.resources.resourceName"
                    placeholder="Resource Name">
                <mat-error *ngIf="isSubmit && resourceName.invalid">
                    <div *ngIf="resourceName.errors.required">Resource Name is required</div>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="col-md-10">
                <mat-label>Resource Description</mat-label>
                <textarea matInput required autocomplete="off" name="description" #resourceName=ngModel [(ngModel)]="content.resources.description"
                    placeholder="Resource Description"></textarea>
            </mat-form-field>
            
            <div class="row" style="justify-content: center">
                <input #addResourceUploader class="addResourceUploader" type="file" (click)="addResourceUploader.value=null" hidden name="avatar"
                    (change)="onFileChange($event.target.files)" />


                <button class="col-5 mb-2 mt-2 btn btn-browse" type="button" (click)="uploadFiles()">{{ "Button.upload_document" | translate}}</button>

            </div>
            <mat-form-field class="col-md-10">
                <mat-label>Resource Link</mat-label>
                <input matInput required autocomplete="off" name="resourceUrl" #resourceUrl=ngModel [(ngModel)]="content.resources.resourceUrl"
                    placeholder="Resource Link">
                <mat-error *ngIf="isSubmit && resourceUrl.invalid">
                    <div *ngIf="resourceUrl.errors.required">Resource Link is required</div>
                </mat-error>
            </mat-form-field>
            <mat-form-field class="col-md-10">
                <mat-label>Resource Group</mat-label>
                <input matInput required name="resourceGroup" #resourceGroup=ngModel [matAutocomplete]="auto" [(ngModel)]="content.resources.resourceGroup"
                    placeholder="Resource Group">
                <mat-autocomplete #auto="matAutocomplete">
                    <mat-option *ngFor="let group of Groups" [value]="group">
                        {{group}}
                    </mat-option>
                </mat-autocomplete>
                <mat-error *ngIf="isSubmit && resourceGroup.invalid">
                    <div *ngIf="resourceGroup.errors.required">Resource Group is required</div>
                </mat-error>
            </mat-form-field>
            
            <div class="col-md-10">
                <mat-label>New Resource</mat-label> &nbsp;&nbsp;
                <mat-checkbox name="newResource" #newResource=ngModel [(ngModel)]="content.resources.isNewResource"></mat-checkbox>
            </div>

            <mat-form-field class="col-md-10">
                <mat-label>Search Keywords</mat-label>
                <input matInput autocomplete="off" name="searchKeywords" #resourceName=ngModel [(ngModel)]="content.resources.searchKeywords"
                    placeholder="Comma seperated search keywords">
            </mat-form-field>
        </form>
    </div>

    <div mat-dialog-actions class="dialog-actions">
        <span>
            <button class="btn btn-default" (click)="onSelect()">Save</button>
        </span>
        <span class="ml-2">
            <button class="btn btn-secondary" (click)="onCancel()">Cancel</button>
        </span>
    </div>
</div>